import styled from '@emotion/styled'
import {
  Theme,
  spacing,
  Typography,
  FormControlLabel,
  Checkbox,
  MuiRadio as Radio,
  MuiTextField as Input,
  palette,
  IconTooltip,
} from '@yuno/design-system-web'

export const ChecboxContainer = styled.div`
  white-space: nowrap;
  width: 33%;
`

export const CheckboxStyled = styled(Checkbox)(() => ({
  padding: '6px',
  '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
    fontSize: '20px',
  },
}))

export const CheckboxCustomStyled = styled(Checkbox)(() => ({
  padding: '6px 6px 6px 0',
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
    fontSize: '20px',
  }
}))

export const Condition = styled(Typography)(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.tiny.regular,
  color: theme.palette.grey[6],
}))

export const FormControlLabelStyled = styled(FormControlLabel)(
  ({ theme }: { theme?: Theme }) => ({
    '& .MuiTypography-root': {
      color: theme.palette.neutral.black,
      ...theme.typography.tiny.regular,
    },
  }),
)

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 20px 0;
`

export const InputKeyButton = styled.button(() => ({
  background: 'none',
  border: 'none',
  color: palette.grey[5],
  cursor: 'pointer',
  padding: '4px 8px',
  position: 'absolute',
  right: '8px',
  top: '38px',

  '& :hover': {
    color: palette.primary[1],
  },
}))

export const InputRemoveButton = styled.button`
  background: none;
  position: absolute;
  top: 37px;
  right: 8px;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
`
export const InputAvailableFields = styled(Input)<{ type: string }>`
& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled {
  font-size: ${({ type }) => type === 'password' ? '22px' : '16px'};
  height: ${({ type }) => type === 'password' ? '23px' : '16px'};
}
`

export const IconTooltipStyled = styled(IconTooltip)(({ theme, marginBottom = true }: { theme?: Theme, marginBottom?: boolean }) => ({
  marginRight: '4px',
  marginBottom: marginBottom ? spacing.m : '0',
  color: theme.palette.grey[4],
  '&:hover': {
    color: 'blue'
  } 
}))

export const TooltipContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const InputContainer = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  fontSize: '10px',
}))

export const InputLabelStyled = styled.div<{ theme?: Theme; focused: boolean }>`
  color: ${({ theme, focused }) =>
    focused ? theme.palette.vivid.brand : theme.palette.neutral.black};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  margin-bottom: ${spacing.m};
`

export const CheckboxContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const CheckboxLabelStyled = styled.div<{ theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
`

export const PaymentMethodsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
`

export const RadioButtonContainer = styled.div`
  margin-top: 12px;
`

export const RadioMuiStyled = styled(Radio)({
  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
})

export const SpanCredentialsStyled = styled.div<{ theme?: Theme }>`
  color: ${({ theme }) => theme.palette.grey[4]};
  font-size: 12px;
  padding: 4px 8px;
  position: absolute;
  right: 8px;
  top: 35px;
`

export const Title = styled(Typography)(({ theme }: { theme?: Theme }) => ({
  ...theme.typography.tiny.regular,
  color: theme.palette.neutral.black,
}))
